import m from "../../geodata/es2015/cyprusLow";
window.am4geodata_cyprusLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cyprusLow.js
// module id = null
// module chunks = 